import styles from './ProductCard.module.css';

type ProductCardProps = {
  title: string;
  subtitle: string;
  description: string;
  mediaSrc: string;
};

export const ProductCard = ({ title, subtitle, description, mediaSrc }: ProductCardProps) => {
  return (
    <div className={styles.cardRoot}>
      <div className={styles.cardTextContentContainer}>
        <span className={styles.cardTitle}>{title}</span>
        <span className={styles.cardSubtitle}>{subtitle}</span>
        <p className={styles.cardDescription}>{description}</p>
      </div>
      <div className={styles.cardMediaContainer}>
        <img src={mediaSrc} alt={`${subtitle} media`} />
      </div>
    </div>
  );
};
